import { useMemo } from "react"

import { InstallationReferenceObj } from "scrivito/Objs/InstallationReference/InstallationReferenceObjClass"

import { InstallationReferenceFilterState } from "../types/InstallationReferenceFilterState"
import { useInstallationReferenceFilter } from "./useInstallationReferenceFilter"
import { useInstallationReferenceObjTransformer } from "./useInstallationReferenceObjTransformer"

interface UseInstallationReferenceFilterArgs {
  installationReferenceObjs: InstallationReferenceObj[] | undefined
  filters: InstallationReferenceFilterState | null | undefined
}

export function useInstallationReferenceObjFilter({
  installationReferenceObjs,
  filters
}: UseInstallationReferenceFilterArgs) {
  const installationReferences = useInstallationReferenceObjTransformer({
    installationReferenceObjs
  })

  const filteredInstallationReferences = useInstallationReferenceFilter({
    installationReferences,
    filters
  })

  return useMemo(
    () =>
      filteredInstallationReferences
        ?.map(f => f.__obj)
        .filter(Boolean) as InstallationReferenceObj[],
    [filteredInstallationReferences]
  )
}
